let productsSlider;
window.addEventListener('DOMContentLoaded', () => {
  productsSlider = new Swiper('.products-slider', {
    slidesPerView: 1.7,
    spaceBetween: 10,
    breakpoints: {
      750: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      990: {
        slidesPerView: 5
      }
    },
    navigation: {
      prevEl: '.products-slider__button.prev',
      nextEl: '.products-slider__button.next',
    },
    pagination: {
      el: '.products-slider__pagination',
      clickable: true
    }
  });
});